'use strict';

// Class Definition
var KTLogin = (function () {
    var _login;

    var _showForm = function (form) {
        var cls = 'login-' + form + '-on';
        var form = 'kt_login_' + form + '_form';

        _login.removeClass('login-forgot-on');
        _login.removeClass('login-signin-on');
        _login.removeClass('login-signup-on');

        _login.addClass(cls);

        KTUtil.animateClass(KTUtil.getById(form), 'animate__animated animate__faster animate__backInUp');
    };

    var _handleSignInForm = function () {
        var validation;

        // Init form validation rules. For more info check the FormValidation plugin's official documentation:https://formvalidation.io/
        validation = FormValidation.formValidation(KTUtil.getById('kt_login_signin_form'), {
            fields: {
                email: {
                    validators: {
                        notEmpty: {
                            message: 'Um endereço de email é necessário.',
                        },
                        emailAddress: {
                            message: 'Este não é um email válido!',
                        }
                    },
                },
                senha: {
                    validators: {
                        notEmpty: {
                            message: 'O campo de senha é necessário.',
                        },
                    },
                },
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(), // Validar os inputs a cada tecla pressionada
                submitButton: new FormValidation.plugins.SubmitButton(),
                bootstrap: new FormValidation.plugins.Bootstrap(),
            },
        });

        $('#kt_login_signin_submit').on('click', function (e) {
            e.preventDefault();

            validation.validate().then(function (status) {
                if (status == 'Valid') {
                    const fields = {};

                    jQuery.each($('#kt_login_signin_form').serializeArray(), (_, field) => {
                        fields[field.name] = field.value;
                    });

                    $.post('/login', fields, (data, textStatus) => {
                        if (data.error) {
                            return swal.fire({
                                text: data.error,
                                icon: 'error',
                                buttonsStyling: false,
                                confirmButtonText: 'Ok, entendi!',
                                customClass: {
                                    confirmButton: 'btn font-weight-bold btn-light-primary',
                                },
                            }).then(function () {
                                KTUtil.scrollTop();
                            });
                        }

                        if (textStatus === 'success') {
                            // Redireciona para o dashboard do cliente
                            window.location.pathname = window.location.pathname.replace(/\/login\/?/g, '');
                            return false;
                        }

                        swal.fire({
                            text: 'Parece que foram detectados alguns erros, tente novamente.',
                            icon: 'error',
                            buttonsStyling: false,
                            confirmButtonText: 'Ok, entendi!',
                            customClass: {
                                confirmButton: 'btn font-weight-bold btn-light-primary',
                            },
                        }).then(function () {
                            KTUtil.scrollTop();
                        });
                    }, 'json');
                } else {
                    swal.fire({
                        text: 'Parece que foram detectados alguns erros, tente novamente.',
                        icon: 'error',
                        buttonsStyling: false,
                        confirmButtonText: 'Ok, entendi!',
                        customClass: {
                            confirmButton: 'btn font-weight-bold btn-light-primary',
                        },
                    }).then(function () {
                        KTUtil.scrollTop();
                    });
                }
            });
        });

        // Abrir tela de esqueci minha senha
        $('#kt_login_forgot').on('click', function (e) {
            e.preventDefault();
            _showForm('forgot');
        });

        // Abrir tela de registro
        $('#kt_login_signup').on('click', function (e) {
            e.preventDefault();
            _showForm('signup');
        });
    };

    var _handleForgotForm = function (e) {
        var validation;

        // Init form validation rules. For more info check the FormValidation plugin's official documentation:https://formvalidation.io/
        validation = FormValidation.formValidation(KTUtil.getById('kt_login_forgot_form'), {
            fields: {
                email: {
                    validators: {
                        notEmpty: {
                            message: 'Um endereço de email é necessário.',
                        },
                        emailAddress: {
                            message: 'Este não é um email válido!',
                        }
                    },
                },
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(), // Validar os inputs a cada tecla pressionada
                submitButton: new FormValidation.plugins.SubmitButton(),
                bootstrap: new FormValidation.plugins.Bootstrap(),
            },
        });

        // Handle submit button
        $('#kt_login_forgot_submit').on('click', function (e) {
            e.preventDefault();

            validation.validate().then(function (status) {
                if (status == 'Valid') {
                    $('#kt_login_forgot_submit').prop('disabled', true);
                    $('#kt_login_forgot_submit').addClass('spinner spinner-white spinner-right');

                    $.ajax({
                        type: "POST",
                        url: '/api/recuperar-senha',
                        data: {
                            email: $('#recuperarSenha').val(),
                            'g-recaptcha-response': grecaptcha.getResponse()
                        },
                        complete: () => {
                            $('#kt_login_forgot_submit').prop('disabled', false);
                            $('#kt_login_forgot_submit').removeClass('spinner spinner-white spinner-right');
                            grecaptcha.reset();
                        },
                        success: (_, textStatus) => {
                            if (textStatus === 'success') {
                                _showForm('signin');
                                return swal.fire('Enviamos um email com as instruções para a recuperação da sua conta.', '', 'success');
                            } else if (textStatus === 'nocontent') {
                                return swal.fire({
                                    text: 'Não encontramos nenhuma conta com este email, verifique se você digitou certo.',
                                    icon: 'error',
                                    buttonsStyling: false,
                                    confirmButtonText: 'Ok, entendi!',
                                    customClass: {
                                        confirmButton: 'btn font-weight-bold btn-light-primary',
                                    },
                                }).then(function () {
                                    KTUtil.scrollTop();
                                });
                            }
                        },
                        error: ({
                            responseText
                        }) => {
                            const responseJSON = JSON.parse(responseText);

                            swal.fire({
                                text: responseJSON ? responseJSON.error : 'Parece que foram detectados alguns erros, tente novamente.',
                                icon: 'error',
                                buttonsStyling: false,
                                confirmButtonText: 'Ok, entendi!',
                                customClass: {
                                    confirmButton: 'btn font-weight-bold btn-light-primary',
                                },
                            }).then(function () {
                                KTUtil.scrollTop();
                            });
                        }
                    });

                    return false;
                }

                swal.fire({
                    text: 'Parece que foram detectados alguns erros, tente novamente.',
                    icon: 'error',
                    buttonsStyling: false,
                    confirmButtonText: 'Ok, entendi!',
                    customClass: {
                        confirmButton: 'btn font-weight-bold btn-light-primary',
                    },
                }).then(function () {
                    KTUtil.scrollTop();
                });
            });
        });

        // Handle cancel button
        $('#kt_login_forgot_cancel').on('click', function (e) {
            e.preventDefault();

            _showForm('signin');
        });
    };

    // Public Functions
    return {
        // public functions
        init: function () {
            _login = $('#kt_login');

            _handleSignInForm();
            // _handleSignUpForm();
            _handleForgotForm();
        },
    };
})();

// Class Initialization
jQuery(document).ready(function () {
    KTLogin.init();
});
